// src/App.jsx
import { useEffect } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import SheepGuardianLanding, { ThankYou, Contact } from "./pages/SheepGuardianLanding";
import { getAttributionMetadata, trackEvent } from "./utils/analytics";

// Temporary Ploughing 2026 campaign link -> Stripe payment page.
const PLOUGHING_2026_PAYMENT_URL =
  "https://pay.sheepguardian.com/b/4gM6oHdig8nLbYFdyk9sk01";

function AttributionTracker() {
  const location = useLocation();

  useEffect(() => {
    getAttributionMetadata();
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function Ploughing2026Redirect() {
  useEffect(() => {
    trackEvent("ploughing2026_redirect", {
      campaign: "ploughing2026",
      destination: PLOUGHING_2026_PAYMENT_URL,
    });

    const search = window.location.search.replace(/^\?/, "");
    const target = search
      ? `${PLOUGHING_2026_PAYMENT_URL}?${search}`
      : PLOUGHING_2026_PAYMENT_URL;

    window.location.replace(target);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-200 text-center p-6">
      <div>
        <p>Taking you to secure checkout…</p>
        <p>
          If nothing happens,{" "}
          <a className="text-sky-400 underline" href={PLOUGHING_2026_PAYMENT_URL}>
            tap here to continue
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AttributionTracker />
      <Routes>
        <Route path="/" element={<SheepGuardianLanding />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ploughing2026" element={<Ploughing2026Redirect />} />
      </Routes>
    </HashRouter>
  );
}
